<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-form
      class="mx-auto small-page-width"
      @submit.prevent="save()"
    >
      <v-card
        v-if="!serverPreview"
        :style="{ position: 'relative' }"
      >
        <v-card-title>
          {{ $t('submit_a_server') }}
        </v-card-title>
        <v-divider />
        <v-card-text>
          <ResourceSelect
            v-model="item.data.game_id"
            :error-messages="errorsByField.game_id"
            :hide-details="!errorsByField.game_id"
            :label="$t('game')"
            :model="models.Game"
            outlined
          />
          <v-container
            class="pa-0"
            fluid
          >
            <v-row>
              <v-col
                cols="8"
              >
                <v-text-field
                  v-model="item.data.host"
                  :disabled="!item.data.game_id"
                  :error-messages="errorsByField.host"
                  :hide-details="!errorsByField.host"
                  :label="$t('host')"
                  outlined
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="item.data.port"
                  :disabled="!item.data.game_id"
                  :error-messages="errorsByField.port"
                  :hide-details="!errorsByField.port"
                  :label="$t('port')"
                  type="number"
                  outlined
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            color="secondary"
            :disabled="isDisabled || isLoading"
            text
            type="submit"
          >
            {{ $t('submit') }}
          </v-btn>
        </v-card-actions>
        <Overlay
          v-if="isLoading"
        />
      </v-card>
      <v-card
        v-if="serverPreview"
      >
        <v-card-title>
          <v-icon
            class="mr-2"
            color="green"
          >
            check_circle_outline
          </v-icon>
          {{ $t('server_found') }}
        </v-card-title>
        <v-divider />
        <ServerPreviewCard
          flat
          :game="serverPreview.data.game"
          :item="serverPreview"
          link
        />
        <v-divider />
        <v-card-actions>
          <v-btn
            color="secondary"
            text
            :to="{ name: 'server.show', params: { serverId: serverPreview.data.id } }"
          >
            {{ $t('go_to_profile') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
import { Game, Server } from '@serversgg/sdk-js'

import errorHandlerMixin from '@/mixins/errorHandlerMixin'
import Overlay from '@/components/Overlay'
import ResourceSelect from '@/components/ResourceSelect'
import ServerPreviewCard from '@/components/ServerPreviewCard'

export default {
  name: 'ServerCreateView',

  components: {
    Overlay,
    ResourceSelect,
    ServerPreviewCard,
  },

  mixins: [
    errorHandlerMixin,
  ],

  data () {
    return {
      isLoading: false,
      item: new Server(),
      models: {
        Game,
      },
      serverPreview: null,
    }
  },

  computed: {
    isDisabled () {
      return !this.item.data.host || !this.item.data.port
    },
  },

  metaInfo () {
    return {
      title: this.$t('submit_a_server'),
    }
  },

  methods: {
    async save () {
      if (this.isLoading) {
        return
      }

      this.isLoading = true

      try {
        const servers = await Server
          .request()
          .setInclude('game')
          .fetch({
            game_id: this.item.data.game_id,
            host: this.item.data.host,
            port: this.item.data.port,
          })

        if (servers.getTotal() > 0) {
          this.serverPreview = servers.all()[0]
          this.isLoading = false
          return
        }
      } catch (e) {
        // Do nothing.
      }

      try {
        await this.item
          .request()
          .setInclude('game')
          .save()

        this.serverPreview = this.item
      } catch (e) {
        await this.handleException(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
